import React, { useContext, useState, useEffect } from "react";
import "./index.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import "./index.css";
import patientAvatar from "./icons/avatar.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import ReactStars from "react-rating-stars-component";
import axios from "axios";
import useUser from "../../context/user/useUser";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../auth/authenticate";
import { CircularProgress } from "@mui/material";
import { api } from "services/ApiService";
import { ApiEndpoint, Method } from "config/constants/apiConstants";
import pharmacyAvatar from "./icons/pharmacyAvatar.jpg";
import favoriteIcon from "./icons/favorite.png";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PaginationComponent from "components/common/pagination/PaginationComponent";
import { PHARMACY_SERVICE_TYPES, SERVING_AREAS } from "constants/constants";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#ffffff",
  color: "#8f8f8f",
  boxShadow: "1px 1px 1px 1px #d1d1d1",
  // '&:hover': {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
  marginRight: theme.spacing(2),
  width: "100%",
  height: "50px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(5),
    width: "70%",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.5, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      // width: "23ch",
    },
  },
}));

const Favourites = (props) => {
  const navigate = useNavigate();
  // let userValue = useContext(UserContext);
  // let { user_id, user_type } = userValue;
  const user_type = 2;

  const [filterDoctors, setFilterDoctors] = React.useState("doctors");
  const [input, setinput] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [doctors, setDoctors] = React.useState([]);
  const [pharmacies, setPharmacies] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [isDoctors, setIsDoctors] = useState(true);
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const [limit, setLimit] = React.useState(10);
  const [offset, setOffset] = React.useState(0);
  //Advance search
  const [serviceAreaAS, setServiceAreaAS] = useState("");
  const [deliveryAreaAS, setDeliveryAreaAS] = useState(0);
  //Doctor
  const [categories, setCategories] = useState([]);
  const [experienceYears, setExperienceYears] = React.useState(null);
  const [rating, setRating] = React.useState(0);
  const [category, setCategory] = useState("");
  const [servingAreas, setServingAreas] = useState("");
  const [gender, setGender] = useState("");

  useEffect(() => {
    if (isDoctors) {
      fetchDoctors();
    } else {
      fetchPharmacies();
    }
  }, [isDoctors, page]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchDoctors = async (isSearch = false) => {
    setLoading(true);

    let obj = {
      offset: offset,
      limit: limit,
      gender: gender === "" || gender === "ALL" ? null : gender,
      service:
        experienceYears === "" || experienceYears === 0
          ? null
          : experienceYears,
      serviceArea:
        servingAreas === "" || servingAreas === "ALL" ? null : servingAreas,
      serviceCategory: category === "" || category === "ALL" ? null : category,
      reviewCount: rating > 0 ? rating : null,
      search: input !== "" ? input : null,
    };

    const result = await api(
      ApiEndpoint.GET_FAVOURITE_DOCTORS_FOR_PATIENT,
      Method.GET,
      obj,
      null
    );
    setDoctors(result?.data?.data);
    setPageCount(Math.ceil(result?.data?.dataCount / limit));
    setLoading(false);
  };
  const fetchPharmacies = async (isSearch = false) => {
    setLoading(true);
    let obj = {
      offset: offset,
      limit: limit,
      search: input !== "" ? input : null,
      distance: deliveryAreaAS > 0 ? deliveryAreaAS : null,
      serviceArea:
        serviceAreaAS === "" || serviceAreaAS === "ALL" ? null : serviceAreaAS,
    };

    const result = await api(
      ApiEndpoint.GET_FAVOURITE_PHARMACIES_FOR_PATIENT,
      Method.GET,
      obj,
      null
    );
    setPharmacies(result?.data?.data);
    setPageCount(Math.ceil(result?.data?.dataCount / limit));
    setLoading(false);
  };

  const fetchCategories = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/category`
    );
    let array = [];
    response?.data?.data?.forEach((item) => {
      array.push({ label: item.name, value: item.name });
    });
    setCategories(array);
  };

  const handleSelectChange = (event) => {
    setFilterDoctors(event.target.value);
    setinput("");
    setOffset(0);
    setPage(1);
    if (event.target.value === "doctors") {
      setIsDoctors(true);
    } else if (event.target.value === "pharmacies") {
      setIsDoctors(false);
    }
  };

  const handleChange = (value) => {
    setPage(value);
    if (value - 1 > 0) {
      setOffset((value - 1) * limit);
    } else {
      setOffset(0);
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawer({ ...openDrawer, [anchor]: open });
  };

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const addToFavourites = async (id) => {
    const result = await api(
      ApiEndpoint.ADD_TO_FAVOURITE_PHARMACIES + id,
      Method.GET,
      null,
      null
    );
    if (result) {
      alert("Added to favourites successfully");
      fetchPharmacies();
    }
  };

  const removeFromFavourites = async (id) => {
    const result = await api(
      ApiEndpoint.REMOVE_FROM_FAVOURITE_PHARMACIES + id,
      Method.DELETE,
      null,
      null
    );
    if (result) {
      alert("Removed from favourites successfully");
      fetchPharmacies();
    }
  };

  const triggerSearch = () => {
    setOffset(0);
    setPage(1);
    setOpenDrawer({ ...openDrawer, ["right"]: false });
    if (isDoctors) {
      fetchDoctors();
    } else {
      fetchPharmacies();
    }
  };

  const resetAdvanceSearch = async (fromReset = false) => {
    setServiceAreaAS("");
    setDeliveryAreaAS(0);

    setExperienceYears("");
    setRating(0);
    setCategory("");
    setServingAreas("");
    setGender("");
    setinput("");
  };

  if (loading) {
    return (
      <center style={{ marginTop: 250 }}>
        <CircularProgress />
      </center>
    );
  }
  return (
    <>
      {/* setting drawer */}
      <div>
        <React.Fragment>
          <Drawer
            anchor={"right"}
            open={openDrawer["right"]}
            onClose={toggleDrawer("right", false)}
          >
            <>
              <div className="filter-drawer-main">
                <div
                  className="close-icon"
                  onClick={toggleDrawer("right", false)}
                >
                  <CloseIcon />
                </div>
                <p className="filter-heading">Search by Filter</p>
                {isDoctors ? (
                  <>
                    <div className="filter-dropdown">
                      <select
                        name="gender"
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option>Gender</option>
                        <option value="ALL">All</option>
                        <option value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                      </select>
                      <input
                        type="number"
                        min={0}
                        value={experienceYears}
                        onChange={(e) =>
                          setExperienceYears(parseInt(e.target.value))
                        }
                        placeholder="Service Experience"
                      />
                      <select
                        name="categories"
                        id="categories"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option>Service Categories</option>
                        <option value="ALL">All</option>
                        {categories?.map((i, key) => (
                          <option key={key} value={i.value}>
                            {i.label}
                          </option>
                        ))}
                      </select>
                      <select
                        name="areas"
                        id="areas"
                        value={servingAreas}
                        onChange={(e) => setServingAreas(e.target.value)}
                      >
                        <option>Serving Areas</option>
                        <option value="ALL">All</option>
                        {SERVING_AREAS.map((i, key) => (
                          <option key={key} value={i.value}>
                            {i.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="filter-star">
                      <ReactStars
                        count={5}
                        onChange={ratingChanged}
                        size={32}
                        value={rating}
                        activeColor="#F6D060"
                      />
                      <p>{"&"} Up</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="filter-dropdown">
                      <select
                        onChange={(e) => setServiceAreaAS(e.target.value)}
                        name="Service Area"
                        id="gender"
                        value={serviceAreaAS}
                      >
                        <option value="">Service Area</option>
                        <option value="ALL">All</option>
                        <option value={PHARMACY_SERVICE_TYPES.ON_SIGHT}>
                          On Site
                        </option>
                        <option value={PHARMACY_SERVICE_TYPES.HOME_DELIVERY}>
                          Home Delivery
                        </option>
                        <option value={PHARMACY_SERVICE_TYPES.BOTH}>
                          Both
                        </option>
                      </select>
                    </div>
                    <div className="filter-star">
                      <h5 style={{ width: "250px" }}>Delivery Distance</h5>
                      <input
                        onChange={(e) => setDeliveryAreaAS(e.target.value)}
                        value={deliveryAreaAS}
                        type="number"
                        min="0"
                        step="1"
                        defaultValue={0}
                        onInput="validity.valid||(value='');"
                        style={styles.basicInput}
                      ></input>
                    </div>
                  </>
                )}
              </div>
              <div className="drawer-btn">
                <Button
                  variant="contained"
                  onClick={() => resetAdvanceSearch()}
                >
                  Reset
                </Button>
                <Button variant="contained" onClick={triggerSearch}>
                  Done
                </Button>
              </div>
            </>
          </Drawer>
        </React.Fragment>
      </div>

      <div className="patientMain">
        <>
          <Grid container className="patientHeadGrid">
            <Grid
              item
              xs={4}
              md={user_type === 4 ? 2 : 3}
              lg={user_type === 4 ? 3 : 5}
            >
              <div className="mainHeading">
                <h3>Favourites</h3>
              </div>
            </Grid>

            <Grid
              item
              xs={7}
              md={user_type === 4 ? 2 : 3}
              lg={user_type === 4 ? 2 : 3}
            >
              <Box sx={{ minWidth: 120 }} className="filterDoctors">
                <FormControl fullWidth>
                  <InputLabel id="filter-appointments-label">Filter</InputLabel>
                  <Select
                    value={filterDoctors}
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={handleSelectChange}
                    label="Filter"
                  >
                    <MenuItem value={"doctors"}>Doctors</MenuItem>
                    <MenuItem value={"pharmacies"}>Pharmacies</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            <Grid
              item
              xs={user_type === 2 ? 6 : 5}
              md={user_type === 4 ? 3 : 4}
              lg={3}
            >
              <Search className="searchbarGrid">
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                  value={input}
                  onBlur={(event) => {
                    if (isDoctors) {
                      fetchDoctors(true);
                    } else {
                      fetchPharmacies(true);
                    }
                  }}
                  onChange={(e) => {
                    setinput(e.target.value);
                  }}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      if (isDoctors) {
                        fetchDoctors(true);
                      } else {
                        fetchPharmacies(true);
                      }
                    }
                  }}
                />
              </Search>
            </Grid>
            <Grid item xs={3} md={user_type === 4 ? 1 : 2} lg={1}>
              <div className="tuneIcon" onClick={toggleDrawer("right", true)}>
                <TuneOutlinedIcon />
              </div>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                m: 1,
                width: "100%",
                height: "auto",
              },
            }}
          >
            {isDoctors ? (
              <div className="scroll">
                {doctors?.map((item, ind) => {
                  return (
                    <Link
                      to={`/doctors/${item.doctorId}`}
                      className="patientLink"
                    >
                      <div key={ind}>
                        <Paper elevation={1} className="patientData">
                          <Grid container>
                            <Grid
                              item
                              xs={user_type === 4 ? 6 : 6}
                              md={user_type === 4 ? 2.5 : 3}
                              lg={2}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                className="patientStack"
                              >
                                <Avatar
                                  alt="Patient Avatar"
                                  src={
                                    item?.Doctor?.User?.profileImagePath ||
                                    patientAvatar
                                  }
                                />
                                <div className="doctorName2">
                                  <h5>{item?.Doctor?.name}</h5>
                                  <p>
                                    {item?.serviceCategories?.map(
                                      (item, index) => {
                                        if (
                                          index ===
                                          item?.serviceCategories?.length - 1
                                        ) {
                                          return (
                                            <span key={index}> {item} </span>
                                          );
                                        } else {
                                          return (
                                            <span key={index}> {item} |</span>
                                          );
                                        }
                                      }
                                    )}
                                  </p>
                                </div>
                              </Stack>
                            </Grid>
                            <Grid
                              item
                              xs={3}
                              md={user_type === 4 ? 1 : 2}
                              lg={user_type === 4 ? 1.5 : 2}
                            >
                              <div className="appointments">
                                <p>Experience</p>
                                <h5>{item?.Doctor?.experienceYears} Years</h5>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={user_type === 4 ? 4 : 3}
                              md={user_type === 4 ? 1.5 : 2}
                              lg={user_type === 4 ? 1.5 : 2}
                            >
                              <div className="doctorReviews">
                                <p>Patient Reviews</p>
                                <h5>
                                  {item?.Doctor?.DoctorAnalytic?.reviewCount
                                    ? item?.Doctor?.DoctorAnalytic?.reviewCount
                                    : 0}
                                </h5>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              md={user_type === 4 ? 1.5 : 2}
                              lg={user_type === 4 ? 1.5 : 2}
                            >
                              <div className="reportReading">
                                <p>Report Reading</p>
                                <h5>
                                  {item?.Doctor?.DoctorAnalytic
                                    ?.reportReadingCount
                                    ? item?.Doctor?.DoctorAnalytic
                                        ?.reportReadingCount
                                    : 0}
                                </h5>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              md={user_type === 4 ? 1.5 : 1}
                              lg={user_type === 4 ? 1.5 : 2}
                            >
                              <div className="consulting">
                                <p>Consulting</p>
                                <h5>
                                  {item?.Doctor?.DoctorAnalytic?.consultingCount
                                    ? item?.Doctor?.DoctorAnalytic
                                        ?.consultingCount
                                    : 0}
                                </h5>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              md={user_type === 4 ? 1.5 : 2}
                              lg={user_type === 4 ? 1.5 : 2}
                            >
                              <div className="patientMoreInfo">
                                <p>{`More Infos >>`}</p>
                              </div>
                            </Grid>
                          </Grid>
                        </Paper>
                      </div>
                    </Link>
                  );
                })}
                {doctors?.length === 0 ? (
                  <h4 style={{ textAlign: "center", marginTop: "100px" }}>
                    No Items Found...
                  </h4>
                ) : null}
              </div>
            ) : (
              <div className="scroll">
                {pharmacies?.map((pharmacy, index) => {
                  return (
                    <div key={index}>
                      <Paper elevation={1} className="pharmaciesData">
                        <Grid
                          container
                          className="pharmaciesMainGrid"
                          onClick={() =>
                            navigate(
                              `/pharmacies/pharmacy-info/${pharmacy.pharmacyId}`
                            )
                          }
                        >
                          <Grid item xs={6} md={6} lg={9}>
                            <div className="pharmacyAvatar">
                              <Stack direction="row" spacing={1}>
                                <Avatar
                                  alt="Patient Avatar"
                                  src={
                                    pharmacy?.Pharmacy?.User
                                      ?.profileImagePath || pharmacyAvatar
                                  }
                                  variant="rounded"
                                />
                                <div className="pharmacyName">
                                  <h5>{pharmacy.Pharmacy.businessName}</h5>
                                  <p>{pharmacy.district}</p>
                                </div>
                              </Stack>
                            </div>
                          </Grid>
                          <Grid item xs={2} md={2} lg={1}>
                            <div className="pharmaciesType ">
                              {/* <p>Type</p>
                              <h5>{pharmacy.serviceArea}</h5> */}
                            </div>
                          </Grid>
                          <Grid item xs={2} md={2} lg={1}>
                            <div className="pharmaciesType">
                              {/* <p>Order</p>
                              <h5>N/A</h5> */}
                            </div>
                          </Grid>
                          <Grid item xs={2} md={2} lg={1}>
                            <div className="pharmacyMoreInfo">
                              <h6>More Info {">>"}</h6>
                            </div>
                          </Grid>
                        </Grid>
                      </Paper>
                    </div>
                  );
                })}
                {pharmacies?.length === 0 ? (
                  <h4 style={{ textAlign: "center", marginTop: "100px" }}>
                    No Items Found...
                  </h4>
                ) : null}
              </div>
            )}
          </Box>
          {/* Pagination */}
          {doctors?.length !== 0 && (
            <PaginationComponent
              count={pageCount}
              page={page}
              onChangeItem={handleChange}
            />
          )}
        </>
      </div>
    </>
  );
};
const styles = {
  basicInput: {
    width: "90%",
    outline: "none",
    borderColor: "transparent",
    padding: "-5px",
    marginLeft: "-4px",
  },
};
export { Favourites };
